import {
  FilterPaneState,
  type ModelListConfig,
  QuickPreviewLocation,
  RowClickBehavior,
  ViewType,
} from '@/types/schema/page-configs/model-list'

export const defaultModelListConfig: ModelListConfig = {
  filterPaneState: FilterPaneState.Closed,
  rowClickBehavior: RowClickBehavior.Preview,
  quickPreviewLocation: QuickPreviewLocation.Right,
  viewType: ViewType.Standard,
}
